<template src="./Pharmacy.html" />

<script>
import { useStore } from "@/store/store.js"
import Modal from "@/components/modal-maps/modal.component.vue"
import mixins from "@/Mixins.js"

export default {
  name: "Pharmacy",
  mixins: [mixins],
  components: {
    Modal
  },
  data: () => ({
    patient_id: "",
    medicine: true,
    phamacy_p: false,
    cepSearch: "",
    selected: [],
    medicamentos_pharmacy: [],
    addres: [],
    cepPharmacy: "",
    addressPharmacy: "",
    latPharmacy: "",
    lngPharmacy: "",
    errorStr: "",
    gettingLocation: false,
    naoLocalizado: false,
    order: "ASC",
    order_distance: 250,
    show_input_cep: false,
    transitionName: "fade",
    farmacias: [],
    configs: {
      orderBy: "preco",
      order: "asc",
      filter: ""
    },
    bodyParameters: {},
    invalidFields: {
      zipcode: false
    },
    map: {
      latitude: null,
      longitude: null,
    },
  }),
  setup () {
    const store = useStore()

    return {
      getGoogleAddress: (cep) => store.dispatch("getGoogleAddress", cep),
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  mounted () {
    this.patient_id = this.$session.get("id")
  },
  methods: {
    getPosition(lat, lng) {
      return {
        lat: Number(lat),
        lng: Number(lng)
      };
    },
    googleMaps(lat, lng) {
      return {
        lat: Number(lat),
        lng: Number(lng)
      };
    },
    async searchAddressPharmacy() {
      this.invalidFields.zipcode = !this.cepSearch

      if(!this.invalidFields.zipcode) {
        const response = await this.getAddressByZipcode(this.cepSearch)
        this.invalidFields.zipcode = !response || !response.address

        if (!this.invalidFields.zipcode) {
          const { street, neighborhood, city, state } = response.address

          this.addressPharmacy = `${street}, ${neighborhood} - ${city} / ${state}`
          this.latPharmacy = response.lat
          this.lngPharmacy = response.lng
        }
      }

      if (this.invalidFields.zipcode) {
        this.addressPharmacy = ""
      }
    },

    async getGeolocationPharmacy() {
      if (!("geolocation" in navigator)) {
        this.errorStr = "Geolocalização não está habilitada."
      } else {
        this.gettingLocation = true

        await navigator.geolocation.getCurrentPosition(
          async ({ coords }) => {
            this.$vs.loading()

            if (coords && coords.latitude && coords.longitude) {
              const response = await this.getGoogleAddress({
                lat: coords.latitude,
                lng: coords.longitude,
              })

              if (response) {
                this.addressPharmacy = await response.formatted_address 

                this.latPharmacy = await response.geometry.location.lat
                this.lngPharmacy = await response.geometry.location.lng
                
                this.cepSearch = await response.address_components
                  .find((addr) => (addr.types.includes("postal_code")))
                  .short_name

                this.getPharmacyP()
              } else {
                this.addressPharmacy = ""
                this.invalidFields.zipcode = true
              }
            }
          },
          err => {
            this.gettingLocation = false;
            this.errorStr = err.message;
            alert("Geolocalização não está habilitada.");
          })
        this.$vs.loading.close()
      }
    },
    getPharmacyP() {
      const vm = this;
      vm.phamacy_p = true;
      vm.$vs.loading();
      vm.axios
        .post(
          `${vm.$store.state.filooServer}orizon/farma/`,
          (vm.bodyParameters = {
            latitude: vm.latPharmacy,
            longitude: vm.lngPharmacy
          })
        )
        .then(response => {
          var array = response.data;
          var result = [];

          for (var i = 0; i < array.length; i++) {
            if (array[i].distancia.includes(" m")){
              array[i].distancia = "0.".concat(array[i].distancia)
            }
            result.push(array[i]);
          }
          vm.farmacias = result.sort((a, b) => a.distancia.replace(/[^\d.-]/g, '') - b.distancia.replace(/[^\d.-]/g, ''));
        })
        .finally(() => {
          vm.$vs.loading.close();
        });
    },

    maskMoney(value) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      });
      var newValue = parseFloat(value);
      var newValueFormat = formatter.format(newValue);
      return newValueFormat;
    },

    seePharmacy(pharmacy, distance) {
      const exp = pharmacy.replace("[\\d.]", "").split(".")

      return (parseInt(exp[0]) <= parseInt(distance))
    },

    showMap(latitude, longitude) {
      this.map = {
        latitude,
        longitude,
        };
      this.$bvModal.show("show-pharmacy-on-map");
    }
  }
};
</script>

<style lang="scss" src="./Pharmacy.scss" />
